import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";

export function AreDreamsFiltered(state: IDreamsState) {
    const isFiltered =
        state.onlyShowMasterDreams ||
        state.onlyShowDreamsToReview ||
        state.onlyShowTodaysDreams ||
        state.searchText !== "" ||
        state.selectedDifficulty > 0 ||
        state.selectedCampaignId > 0 ||
        state.selectedEmotion !== "" ||
        state.selectedAttributes.length > 0;

    return isFiltered;
}
